import { Dispatch, SetStateAction } from "react";

export interface UpdateCartHelperFn {
    isCartUpdating: boolean;
    setShowOverlay: Dispatch<SetStateAction<boolean>>;
    setIsCartEmpty: (isCartEmpty: boolean) => void;
    setUpdatingItemId: (id: string) => void;
    updateCart: (payload: Record<string, unknown>) => Promise<void>;
    callbacks?: {
        onSuccess?: VoidFunction;
        onError?: VoidFunction;
    };
}

export interface UpdateCartWithActionOptions {
    updateLogic: (cartItems?: CartItem[]) => CartItem[];
    helperFn: UpdateCartHelperFn;
    updatedDishItems?: CartItem[];
    updateLocalCartInNative?: (cartData: Record<string, unknown>) => void;
    clearLocalCartInNative?: VoidFunction;
}

export interface CartItem {
    unId?: string;
    selectedInfo?: {
        quantity?: {
            value?: number;
        };
    };
    item_instructions?: {
        special_instructions?: string;
    };
    userInstruction?: {
        textContainer?: {
            text?: {
                info?: string;
            };
        };
    };
}

export interface CartActionExtraParams {
    action?: string;
    item?: CartItem;
    setUpdatingItemId?: Dispatch<SetStateAction<string | null>>;
    updatedDishItems?: CartItem[];
    cookingRequestValue?: string;
    cta?: { link: string };
}

export interface CartUpdateOptions {
    isCartUpdating: boolean;
    setShowOverlay: Dispatch<SetStateAction<boolean>>;
    setIsCartEmpty: (isCartEmpty: boolean) => void;
    setUpdatingItemId: (id: string) => void;
    updateCart: (payload: Record<string, unknown>) => Promise<void>;
    updateLocalCartInNative?: (cartData: Record<string, unknown>) => void;
    clearLocalCartInNative?: VoidFunction;
}

export enum InstructionActionType {
    ADD = "add",
    SAVE = "save",
    REMOVE = "remove",
}

export interface HandleInstructionsParams {
    action: InstructionActionType;
    cookingRequestValue?: string;
}

export enum TabType {
    CART = "cart",
    ORDERS = "orders",
}
